import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import './ModalCajaFlujoConcepto.css';
import Loader from '../Loader/Loader';

const ModalCajaFlujoCatalogoSimple = ({
  onSave,
  onClose,
  isOpen,
  itemEditar,
  fieldName,
  title,
  editTitle,
  label,
  placeholder
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ [fieldName]: '' });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        [fieldName]: itemEditar?.[fieldName] || ''
      });
    }
  }, [isOpen, itemEditar, fieldName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (!formData[fieldName].trim()) {
        alert(`${label} es requerido`);
        setLoading(false);
        return;
      }

      await onSave({
        [fieldName]: formData[fieldName].trim()
      });
      onClose();
    } catch (error) {
      console.error("Error al guardar:", error);
      const errorMsg = error.response?.data?.message || 'Ocurrió un error al guardar.';
      alert(`Error: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{itemEditar ? editTitle : title}</h1>
          <Button className="close-btn" onClick={onClose}>X</Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        {loading ? (
          <Loader />
        ) : (
          <ModalBody className="modal-body">
            <Form className="fila" onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Label>{label}:</Label>
                <Input
                  className="form-control"
                  type="text"
                  name={fieldName}
                  value={formData[fieldName]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  maxLength="255"
                  required
                />
              </FormGroup>

              <FormGroup>
                <div className="button-container">
                  <Button
                    className="button-custom"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {itemEditar ? 'ACTUALIZAR' : 'GUARDAR'}
                  </Button>
                </div>
              </FormGroup>
            </Form>
          </ModalBody>
        )}
      </div>
    </Modal>
  );
};

export default ModalCajaFlujoCatalogoSimple;
